export const environment = {
    profile: 'kaiser-prod',
    production: true,
    apiBaseUrl: 'https://fashion42.kaiser-fashion.de/api',
    VERSION: require('../../package.json').version,
};
